import { render, staticRenderFns } from "./otelfirsatiaktarim.vue?vue&type=template&id=315742d7&"
import script from "./otelfirsatiaktarim.vue?vue&type=script&lang=js&"
export * from "./otelfirsatiaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports